<template>
  <div>
    <TheCalendar
      :prop-master-book="masterBook"
      :prop-start-date-of-use="startDateOfUse"
      :prop-on-selected-date="onSelectedDate"
    />

    <slot name="beforeCaution" />

    <MbPurchaseStartedatCaution
      v-if="
        masterBook.content.description_json &&
        masterBook.content.description_json.MbPurchaseStartedatCaution
      "
      :note="masterBook.content.description_json.MbPurchaseStartedatCaution"
    />
  </div>
</template>

<script>
export default {
  name: "TheBbStartDateSelect",
  props: {
    onSelectedDate: {
      type: Function,
      required: true,
    },
    startDateOfUse: {
      type: String,
      required: true,
    },
    masterBook: {
      type: Object,
      required: true,
    },
  },
};
</script>
